import { Route, Outlet } from 'react-router-dom';
import KYC from '../pages/kyc';
import Navbar from '../layouts/Navbar';
import Home from '../pages/home';
import { ProtectedRoute, PublicRoute } from './hoc';
import ConsoleUser from '../pages/consoleUser';
import Profile from '../pages/profile';
import Sidebar from '../layouts/Sidebar';
import { checkRouteAccess } from '../utils/common';
import Login from '../pages/login';
import Users from '../pages/users';
import Wave from '../pages/wave';
import Email from '../pages/Email';
import EmailStatusChart from '../pages/emailStatus';

import AddNewUser from '../pages/addNewUser';
import Advertisement from '../pages/advertisement';
import NotFound from '../pages/notFound';
import PermissionDenied from '../pages/permissionDenied';
import Leads from '../pages/leads';
import Billing from '../pages/billing';
import LeadsAnalysis from 'src/pages/leadsAnalysis';
import UpdatePanelPermission from 'src/pages/updatePermission';
import NewUsers from 'src/pages/createConsoleUser';
import AnnouncementList from 'src/pages/announcementList';
import PlansList from 'src/pages/plans';
import Branding from '../pages/branding';
import AmAnalysis from '../pages/amAnalysis';
import NotificationPopup from 'src/components/SocketNotificationPopup';
import TtsTemplateList from 'src/pages/ttsTemplateList';
import BillingList from '../pages/billingList';
import LoginWithPassword from '../pages/loginWithPassword';
import QuatationAnalysis from '../pages/quataionAnalysis';
import Employee from 'src/pages/employee';
import ReleasePage from 'src/pages/changeLog';
import IncompleteKYC from 'src/pages/IncomleteKyc';
import WhatsappPlans from 'src/pages/whatsappPlans';
import EmployeeDashboard from 'src/pages/employeeDashboard';
import Employee2 from 'src/pages/employee-2';
import EmployeeSummery from 'src/pages/employee-summary';
import VoicePlans from 'src/pages/voicePlans';
import Server from 'src/pages/server';
import UserPlanList from 'src/pages/userPlanList';
import VoiceDeletedUserList from 'src/pages/voiceDeletedUserList';

import Gateways from 'src/pages/smsGateways';
import SmsTemplateList from 'src/pages/smsTemplateList';
import SmsSenderID from 'src/pages/smsSenderID';
import ConsoleAuthList from 'src/pages/consoleAuthList';
import CreateConsoleAuth from 'src/pages/createConsoleAuth';
import VoiceAmountCreditInvoice from 'src/pages/voiceAmountCreditInvoice';
import VoiceDeletedCampaignList from 'src/pages/voiceDeletedCampaignList';
import SmsPlan from 'src/pages/smsPlan';
import SmsActions from 'src/sections/sms/actions/smsActions';
import WalletTabPanel from 'src/pages/paymentInvoice';
import ElasticBackupServer from 'src/pages/voiceElasticBackupServer';
import NegativeUsersBalance from 'src/pages/NegativeUsersBalance';
import VoiceHost from 'src/pages/voiceHost';
import VoiceGateway from 'src/pages/voiceGateway';
import VoiceCli from 'src/pages/voiceCli';
import VoiceTestGateway from 'src/sections/voice/voiceGateway/voiceTestGateway';
import AdminSetting from 'src/pages/AdminSetting';
import AdminSettingList from 'src/pages/AdminSettingList';
import SmsAdminSetting from 'src/pages/SmsAdminSetting';
import SmsAdminSettingList from 'src/pages/SmsAdminSettingList';
import SmsRealNumber from 'src/pages/smsRealNumber';
import RetrySetting from 'src/pages/RetrySetting';
import ImplicitValidityPeriod from 'src/pages/ImplicitValidityPeriod';

const AllRoutes = (key) => {
  return (
    <>
      <Route
        element={
          <>
            <ProtectedRoute>
              <Sidebar />
              <Navbar /> <NotificationPopup /> <Outlet />{' '}
            </ProtectedRoute>
          </>
        }
      >
        {checkRouteAccess('/kyc') && <Route exact path="/kyc" element={<KYC />} />}
        {checkRouteAccess('/console_users') && <Route exact path="/console_users" element={<ConsoleUser />} />}
        {checkRouteAccess('/users') && <Route exact path="/users" element={<Users />} />}
        {checkRouteAccess('/profile') && <Route exact path="/profile" element={<Profile />} />}
        {checkRouteAccess('/home') && <Route exact path="/home" element={<Home />} />}
        {checkRouteAccess('/meet') && <Route exact path="/meet" element={<Wave />} />}
        {checkRouteAccess('/webinar') && <Route exact path="/webinar" element={<Wave />} />}
        {checkRouteAccess('/email') && <Route exact path="/email" element={<Email />} />}
        {checkRouteAccess('/emailStatus') && <Route exact path="/emailStatus" element={<EmailStatusChart />} />}
        {checkRouteAccess('/sms') && <Route exact path="/sms" element={<Gateways />} />}
        {checkRouteAccess('/add_new_user') && <Route exact path="/add_new_user" element={<AddNewUser />} />}
        {checkRouteAccess('/advertisement') && <Route exact path="/advertisement" element={<Advertisement />} />}
        {checkRouteAccess('/leads') && <Route exact path="/leads" element={<Leads />} />}
        {checkRouteAccess('/leads') && <Route exact path="/leads_analysis" element={<LeadsAnalysis />} />}
        {checkRouteAccess('/updatepermissions') && (
          <Route exact path="/updatepermissions" element={<UpdatePanelPermission />} />
        )}
        {checkRouteAccess('/createUser') && <Route exact path="/createUser" element={<NewUsers />} />}
        {checkRouteAccess('/createUser') && <Route exact path="/updateUser" element={<NewUsers />} />}
        {checkRouteAccess('/announcementList') && (
          <Route exact path="/announcementList" element={<AnnouncementList type="announcement" />} />
        )}
        {checkRouteAccess('/ivrList') && <Route exact path="/ivrList" element={<AnnouncementList page="ivr" />} />}
        {checkRouteAccess('/ttsTemplateList') && <Route exact path="/ttsTemplateList" element={<TtsTemplateList />} />}
        {checkRouteAccess('/smsTemplateList') && <Route exact path="/smsTemplateList" element={<SmsTemplateList />} />}
        {checkRouteAccess('/senderIdList') && <Route exact path="/senderIdList" element={<SmsSenderID />} />}
        {checkRouteAccess('/plans') && <Route exact path="/plans" element={<PlansList />} />}
        {checkRouteAccess('/billing') && <Route exact path="/create_quotation" element={<BillingList />} />}
        {checkRouteAccess('/billing') && <Route exact path="/billing" element={<Billing />} />}
        {checkRouteAccess('/billing') && <Route exact path="/quotation_analysis" element={<QuatationAnalysis />} />}
        {checkRouteAccess('/branding') && <Route exact path="/branding" element={<Branding />} />}
        {checkRouteAccess('/whatsapp_plans') && <Route exact path="/whatsapp_plans" element={<WhatsappPlans />} />}
        {checkRouteAccess('/voice_plans') && <Route exact path="/voice_plans" element={<VoicePlans />} />}
        {checkRouteAccess('/server') && <Route exact path="/server" element={<Server />} />}
        {checkRouteAccess('/voice-deleted-userList') && (
          <Route exact path="/voice-deleted-userList" element={<VoiceDeletedUserList />} />
        )}
        {checkRouteAccess('/voice-credit-amount-invoice') && (
          <Route exact path="/voice-credit-amount-invoice" element={<VoiceAmountCreditInvoice />} />
        )}
        {checkRouteAccess('/voice_deleted_campaign_list') && (
          <Route exact path="/voice_deleted_campaign_list" element={<VoiceDeletedCampaignList />} />
        )}
        {checkRouteAccess('/smsPlans') && <Route exact path="/smsPlans" element={<SmsPlan />} />}
        {checkRouteAccess('/smsPlans') && <Route exact path="/smsPlanAssign" element={<SmsActions />} />}
        {checkRouteAccess('/elastic_backup_server') && <Route exact path="/elasticBackupServer" element={<ElasticBackupServer />} />}
        {checkRouteAccess('/NegativeVoiceBalance') && <Route exact path="/NegativeVoiceBalance" element={<NegativeUsersBalance />} />}
        {checkRouteAccess('/voiceHost') && (<Route exact path="/voiceHost" element={< VoiceHost/>} />) }
        {checkRouteAccess('/voiceGateway') && (<Route exact path="/voiceGateway" element={< VoiceGateway/>} />) }
        {checkRouteAccess('/voiceCli') && (<Route exact path="/voiceCli" element={< VoiceCli/>} />) }
        {checkRouteAccess('/voiceGateway') && (<Route exact path="/VoiceTestGateway" element={< VoiceTestGateway />} />) }
        {checkRouteAccess('/voiceAdminSetting') && <Route  exact path="/voiceAdminSetting" element={<AdminSetting/>}/>}
        {checkRouteAccess('/voiceAdminSetting') && <Route  exact path="/voiceAdminSettingList" element={<AdminSettingList/>}/>}
        {checkRouteAccess('/smsAdminSetting') && <Route exact path="/smsAdminSetting" element={<SmsAdminSetting />} />}
        {checkRouteAccess('/smsAdminSettingList') && <Route exact path="/smsAdminSettingList" element={<SmsAdminSettingList />} />}
        {checkRouteAccess('/smsRealNumber') && <Route exact path="/smsRealNumber" element={<SmsRealNumber />} />}
        {checkRouteAccess('/retrySettings') && <Route exact path="/retrySettings" element={<RetrySetting />} />}
        {checkRouteAccess('/implicitValidityPeriod') && <Route  exact path="/implicitValidityPeriod" element={<ImplicitValidityPeriod />} />}


        {true && <Route  exact path="/invoice" element={<WalletTabPanel/>}/>}
        {true && <Route exact path="/userPlanList" element={<UserPlanList />} />}
        {true && <Route exact path="/amAnalysis" element={<AmAnalysis />} />}
        {true && <Route exact path="/hrmsList" element={<Employee />} />}
        {true && <Route exact path="/hrmsReport" element={<Employee2 />} />}
        {true && <Route exact path="/hrmsSummary" element={<EmployeeSummery />} />}
        {true && <Route exact path="/hrms" element={<EmployeeDashboard />} />}
        {true && <Route exact path="/release" element={<ReleasePage />} />}
        {true && <Route exact path="/kycNotification" element={<IncompleteKYC />} />}
        {checkRouteAccess('/console_auth') && <Route exact path="/console_auth" element={<ConsoleAuthList />} />}
        {/* {true && <Route exact path="/console_auth" element={<ConsoleAuthList />} />} */}
        {checkRouteAccess('/admin-setting') && <Route exact path="/createConsoleAuth" element={<CreateConsoleAuth />} />}

        {/* <Route exact path="/updateUser" element={<NewUsers />} /> */}
      </Route>

      <Route
        element={
          <>
            <PublicRoute>
              <Outlet />
            </PublicRoute>
          </>
        }
      >
        {key ? <Route exact path="/" element={<LoginWithPassword />} /> : <Route exact path="/" element={<Login />} />}
      </Route>

      {/* <Route element={<><PublicRoute ><Outlet /></PublicRoute> </>}>
                <Route exact path="/" element={<Login />} />
            </Route> */}

      <Route exact path="/permisson_denied" element={<PermissionDenied />} />
      <Route exact path="*" element={<NotFound />} />
    </>
  );
};

export default AllRoutes;
